import { render } from "./CollectionDetailedSearchBooks.vue?vue&type=template&id=7c9c5ded&scoped=true&ts=true"
import script from "./CollectionDetailedSearchBooks.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchBooks.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchBooks.vue?vue&type=style&index=0&id=7c9c5ded&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9c5ded"]])

export default __exports__